
import { defineComponent } from 'vue'
import user from '@/utils/user'
import { getMessage, MessageDto, getUnReadMessage } from '@/api/message'
import { getHelpVideo } from '@/api/home'
import $store from '@/store'
import SwitchClient from '@/views/index/components/switch-client.vue'

export default defineComponent({
    components: { SwitchClient },
    data () {
        return {
            companyName: '',
            isSwitchClientAlert: false,
            qrcode: '',
            messageList: [] as MessageDto[],
            unReadNum: 0,
            showGuide: false,
            helpVideoUrl: '',
            $store
        }
    },
    async created () {
        user.waitLogin().then(async () => {
            // 获取左边的公司名称
            this.companyName = user.companyName
            // 获取小程序码推荐小程序
            this.qrcode = user.miniprogQrcode
            // 获取操作指引视频链接，根据返回结果决定是否展示
            try {
                const helpData = await getHelpVideo({ source: 'pc' })
                this.helpVideoUrl = helpData?.video || ''
            } catch (e) {
                this.helpVideoUrl = ''
            }
            const data = await getUnReadMessage()
            console.log(data, 'getUnReadMessage')
            this.unReadNum = data
        })
    },
    methods: {

        async getMessage () {
            const messageList = await getMessage(
                {
                    page: 1,
                    pageSize: 4
                },
                {
                    isLoading: false
                }
            )
            this.messageList = messageList.data
        },

        // 用户退出
        exit () {
            user.exit()
        },
        // 切换账户
        switchClient () {
            this.isSwitchClientAlert = !this.isSwitchClientAlert
        },
        closeGuide () {
            this.showGuide = false
        }
    }
})
